import { render, staticRenderFns } from "./BackendTechReq.vue?vue&type=template&id=73edee50&"
import script from "./BackendTechReq.vue?vue&type=script&lang=js&"
export * from "./BackendTechReq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports